<h1 mat-dialog-title>Process Order</h1>
<div mat-dialog-content *ngIf="!isLoading">
    <app-display-order-information *ngIf="order" [order]="order"></app-display-order-information>
    <!-- Order Status -->
    <mat-card appearance="outlined">
        <mat-card-header>
            <mat-icon *ngIf="!status || !status.name"  class="alert" mat-card-avatar>error</mat-icon>
            <mat-icon *ngIf="status && status.name" color="primary" mat-card-avatar>check</mat-icon>
            <mat-card-title>Order will change status</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div *ngIf="status && status.name" matListItemLine>
                to {{status.name}}
                <button (click)="clearStatus()" mat-button>x</button>
            </div>
            <div *ngIf="!status || !status.name" matListItemLine>
                <mat-form-field>
                    <mat-label>Order Status</mat-label>
                    <mat-select>
                        <mat-option *ngFor="let status of validStatusObjects" (click)="selectStatus(status.id)" [value]="status.id">{{status.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </mat-card-content>
    </mat-card>
    <!-- Order Place -->
    <mat-card appearance="outlined">
        <mat-card-header>
            <mat-icon *ngIf="!placeId"  class="alert" mat-card-avatar>error</mat-icon>
            <mat-icon *ngIf="placeId" color="primary" mat-card-avatar>check</mat-icon>
            <mat-card-title>Order will change location</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div *ngIf="placeId" matListItemLine>
                <app-display-place-field [placeId]="placeId"></app-display-place-field>
                <button (click)="clearPlace()" mat-button>x</button>
            </div>
            <div *ngIf="!placeId" matListItemLine>
                <button (click)="openPlaceDialog()" mat-raised-button color="primary">Select</button>
            </div>
        </mat-card-content>
    </mat-card>
    <!-- Order Schedule Status -->
    <mat-card appearance="outlined">
        <mat-card-header>
            <mat-icon mat-card-avatar color="primary">check</mat-icon>
            <mat-card-title>Order will update on the schedule</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div matListItemLine>to {{calculateNextScheduleOrderStatus(scheduleOrder)}}</div>
        </mat-card-content>
    </mat-card>
    <div mat-dialog-actions>
        <button mat-raised-button mat-dialog-close>Cancel</button>
        <button [disabled]="!status || !placeId" mat-raised-button color="primary" (click)="onSubmit()">Confirm</button>
    </div>
</div>